/*
  SunBorn 9/30 — Keep minicart line order stable across size/color swaps.

  Why lines jumped: Shopify's Ajax cart has no "change this line's variant in
  place". A swap removes the old variant and adds the new one, and Shopify
  lists the newest line FIRST — so the swapped product jumped to the top.

  Fix (display-only, cart contents untouched): the drawer remembers the order
  it last showed (by variant id, per browser tab session). On every drawer
  render:
   - exactly one variant gone + one new variant appeared  => it's a swap: the
     new variant takes the old one's slot;
   - other new variants (real Add To Cart) go on top, as before;
   - removed variants drop out.
  The .cart-item nodes are then re-ordered inside #ajaxcart-cartitems before
  the browser paints. Each item keeps its own data-index / ids, so quantity,
  remove and wishlist controls still target the right Shopify line, and the
  swapper (sunborn-cart-drawer.js) matches lines by variant id, not position.
  Loaded sitewide (defer) from snippets/back-to-top.liquid.
*/
(function () {
  if (window.__sbCartOrder) return;
  window.__sbCartOrder = true;

  var KEY = 'sb-cart-line-order';
  var running = false;

  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(a) {
    try { sessionStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  function vidOf(el) {
    var i = el.querySelector('[data-quantity-variant-id]');
    return i ? i.getAttribute('data-quantity-variant-id') : null;
  }

  function reorder() {
    if (running) return;
    var wrap = document.getElementById('ajaxcart-cartitems');
    if (!wrap) return;
    var els = Array.prototype.filter.call(wrap.children, function (c) {
      return c.classList && c.classList.contains('cart-item');
    });
    if (!els.length) { save([]); return; }
    var cur = els.map(vidOf);
    if (cur.some(function (v) { return !v; })) return;
    /* duplicate variant lines (e.g. line-item properties): leave Shopify's order */
    if (cur.filter(function (v, i) { return cur.indexOf(v) !== i; }).length) { save(cur); return; }

    var last = load();
    var removed = last.filter(function (v) { return cur.indexOf(v) < 0; });
    var added = cur.filter(function (v) { return last.indexOf(v) < 0; });
    var order;
    if (removed.length === 1 && added.length === 1) {
      order = last.map(function (v) { return v === removed[0] ? added[0] : v; });
    } else {
      order = added.concat(last.filter(function (v) { return cur.indexOf(v) > -1; }));
    }

    if (order.join('|') !== cur.join('|')) {
      running = true;
      var anchor = els[els.length - 1].nextSibling;
      order.forEach(function (v) {
        var el = els[cur.indexOf(v)];
        if (el) wrap.insertBefore(el, anchor);
      });
      running = false;
    }
    save(order);
  }

  window.sbCartReorder = reorder;

  function init() {
    var root = document.getElementById('ajaxcart');
    if (!root || !('MutationObserver' in window)) return;
    reorder();
    new MutationObserver(function () { reorder(); }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
